export const autocompleteStyles = (theme) => ({
    formControl: {
        '& .MuiInputBase-root': {
            height: 38,
            padding: 0,
            paddingLeft: 12
        },
        '& .MuiInputBase-input': {
            paddingTop: '8px !important'
        },
        '& fieldset': {
            borderColor: theme.palette.black.full
        }
    }
});

export const buttonStyles = () => ({
    secondaryButton: {
        margin: '0px !important',
        color: 'white',
        backgroundColor: '#3083EC',
        '&:hover': {
            backgroundColor: '#3083EC'
        },
        '&:active': {
            backgroundColor: '#3083EC'
        }
    },
    cancelText: {
        color: '#575A64'
    }
});

export const dateInputStyles = (theme) => ({
    root: {
        '& .MuiOutlinedInput-adornedEnd': {
            paddingRight: 0,
            width: 130
        }
    },
    blackBorder: {
        '& fieldset': {
            borderColor: theme.palette.black.full
        }
    }
});

export const selectStyles = (theme) => ({
    formControl: {
        '& .MuiSelect-select:focus': {
            backgroundColor: 'inherit'
        },
        '& .MuiSelect-root': {
            paddingTop: 22
        },
        '& fieldset': {
            borderColor: theme.palette.black.full
        }
    }
});

export const testFieldStyles = (theme) => ({
    textField: {
        '& fieldset': {
            borderColor: theme.palette.black.full
        }
    }
});

export const badgeLoading = () => ({
    badgeWraper: {
        width: '5.2rem',
        height: 'fit-content',
        zIndex: '1',
        borderRadius: '5px',
        display: 'flex',
        placeContent: 'space-between',
        padding: '4px 7px',
        fontWeight: 'bold',
        fontSize: '12px',
        transition: 'visibility 0s, opacity 0.5s linear',
        '& .MuiCircularProgress-colorPrimary': {
            width: '14px !important',
            height: 'unset !important'
        },
        '& .MuiSvgIcon-root': {
            width: '18px !important',
            height: 'unset !important'
        }
    },
    badgeLoading: {
        backgroundColor: '#fbfb9d',
        width: '5rem'
    },
    badgeComplete: {
        backgroundColor: '#84e595',
        width: '5.5rem'
    },
    centerSpinner: {
        display: 'flex',
        alignItems: 'center'
    }
});

export const smsEditor = () => ({
    smsBtn: {
        cursor: 'pointer',
        marginLeft: 8
    },
    smsInput: {
        '& .MuiInputBase-input': {
            lineHeight: 1.1
        },
        '& textarea::placeholder': {
            fontWeight: 400,
            fontSize: '14px !important',
            color: '#333 !important',
            fontFamily: 'Roboto, Arial, "sans-serif" !important'
        }
    },
    helperText: {
        color: '#9c9c9c',
        fontSize: 12,
        textAlign: 'left'
    },
    marginTop8px: {
        marginTop: 8
    },
    link: {
        color: '#3083EC',
        textTransform: 'none'
    }
});

export const emailEditor = () => ({
    editor: {
        minHeight: 430,
        width: '100%',
        '& .rdw-editor-main, & .cm-s-default': {
            borderColor: '#7C7E86',
            borderStyle: 'solid',
            borderWidth: 1
        }
    }
});

export const messageForm = () => ({
    mergeTagsRoot: {
        width: '100%',
        marginTop: '10px',
        paddingTop: '8px'
    },
    selectRoot: {
        backgroundColor: 'white',
        width: '12rem',
        '& > div > div': {
            boxSizing: 'border-box',
            height: 'inherit'
        },
        '& label.MuiInputLabel-shrink': {
            transform: 'translate(-2px, -2px) scale(0.75)',
            transformOrigin: 'top left'
        }
    },
    selectLabel: {
        fontSize: '14px',
        opacity: 1,
        marginTop: '-0.25rem',
        marginLeft: '1rem'
    },
    testBtn: {
        background: '#3083EC !important',
        margin: '0px 0px!important',
        '&:hover': {
            background: '#3083EC !important',
            boxShadow: 'none'
        }
    }
});

export const urlShorter = () => ({
    urlShorterWraper: {
        border: '1px solid #c4c4c4',
        borderRadius: '4px',
        width: '11rem',
        padding: '1rem',
        position: 'absolute',
        right: '50%',
        zIndex: '2',
        backgroundColor: 'white'
    },
    urlShorterBtn: {
        marginTop: '1rem',
        display: 'flex',
        justifyContent: 'space-between'
    },
    nextBtn: {
        background: '#B41678',
        textTransform: 'none',
        fontSize: 12,
        boxShadow: 'none',
        borderRadius: 0,
        height: '2rem',
        color: 'white',
        '&:hover': {
            background: '#B41678',
            boxShadow: 'none'
        }
    },
    cancelBtn: {
        background: 'white',
        textTransform: 'none',
        fontSize: 12,
        height: '2rem',
        boxShadow: 'none',
        color: '#7C7E86',
        borderColor: '#7C7E86',
        borderStyle: 'solid',
        borderWidth: 1,
        marginRight: 12,
        borderRadius: 0,
        '&:hover': {
            background: 'white',
            boxShadow: 'none'
        }
    }
});

export const messageTest = () => ({
    testBtn: {
        background: '#3083EC !important',
        margin: '0px 0px!important',
        '&:hover': {
            background: '#275fa5 !important',
            boxShadow: 'none'
        },
        '&:active': {
            backgroundColor: '#a5c6ef !important'
        }
    },
    input: {
        '& input': {
            '&::placeholder': {
                fontWeight: 400,
                fontSize: '14px !important',
                color: '#333 !important',
                fontFamily: 'Roboto, Arial, "sans-serif" !important'
            }
        }
    }
});

export const modal = () => ({
    modal: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalHTMLWrapContent: {
        backgroundColor: 'white',
        width: '95%',
        height: '90%',
        borderRadius: '4px',
        padding: '1rem'
    },
    modalHTMLHeader: {
        float: 'left',
        minWidth: '4rem',
        textAlign: 'right',
        marginRight: '1rem'
    },
    hrCustom: {
        width: '97%',
        margin: '1rem 0'
    },
    modalHTMLContent: {
        height: '85%',
        overflow: 'auto'
    }
});
